import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { CornerDownRight } from "lucide-react";

interface IRakeDripEdge {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function RakeDripEdge(props: IRakeDripEdge) {
    const { value, onChange, loading } = { ...props };
    const [rakeDripEdge, setRakeDripEdge] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setRakeDripEdge(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setRakeDripEdge(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Rake Drip Edge
            </Typography>

            <Select
                placeholder="Select rake drip edge"
                value={rakeDripEdge}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<CornerDownRight size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="2*2">2*2</Option>
                <Option value="2*4">2*4</Option>
            </Select>
        </Box>
    );
}
